import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsUngatedForAIDynamicText } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export function previewDynamicTextHandler(editor, promptId) {
  const tokenString = `{{ ai_dynamic_token('${promptId}') }}`;
  // Insert the token into the editor with proper undo handling
  editor.undoManager.transact(() => {
    editor.insertContent(tokenString);
  });
  editor.fire('hsaidynamictokens:tokenInserted');
  // Focus the editor after insertion
  editor.focus();
}
function PreviewFrameDynamicTextSessionManagerInternal() {
  const dispatch = useDispatch();
  useEffect(() => {
    const typedWindow = window;
    typedWindow.LayoutBuilderUI.messenger.setOnAIDynamicTokenInsert(message => {
      var _typedWindow$tinymce;
      const {
        promptId
      } = message.payload;
      const activeEditor = (_typedWindow$tinymce = typedWindow.tinymce) === null || _typedWindow$tinymce === void 0 ? void 0 : _typedWindow$tinymce.activeEditor;
      if (activeEditor) {
        previewDynamicTextHandler(activeEditor, promptId);
      }
    });
    return () => {
      typedWindow.LayoutBuilderUI.messenger.setOnAIDynamicTokenInsert();
    };
  }, [dispatch]);
  return null;
}
function PreviewFrameDynamicTextSessionManager() {
  const isUngatedForAIDynamicText = useSelector(getIsUngatedForAIDynamicText);
  if (!isUngatedForAIDynamicText) {
    return null;
  }
  return /*#__PURE__*/_jsx(PreviewFrameDynamicTextSessionManagerInternal, {});
}
export default PreviewFrameDynamicTextSessionManager;